import type { RaRecord } from "react-admin";

import {
  buildRelayAccessApprovalWhatsAppMessage,
  getRelayEventApprovalLabel,
} from "./relay-access-approval-whatsapp-message";
import { getAccessRequestDisplayName, getAccessRequestMobile, toWhatsAppChatHref } from "./utils";

type RelayEventRef = {
  title?: string | null;
  name?: string | null;
  whatsappGroupLink?: string | null;
};

export function getRelayApprovalWhatsAppContext(record: RaRecord) {
  const relayEvent = record.relayEvent as RelayEventRef | undefined;
  const whatsappGroupLink = relayEvent?.whatsappGroupLink?.trim() ?? "";
  const itsId = String(record.itsId ?? "").trim();
  const name = getAccessRequestDisplayName(record);
  const mobile = getAccessRequestMobile(record) ?? "";
  const missingLink = !whatsappGroupLink;
  const missingContact = !itsId || name === "—" || !mobile;
  const canBuildMessage = !missingLink && !missingContact;
  const message = canBuildMessage
    ? buildRelayAccessApprovalWhatsAppMessage({
        itsId,
        name,
        mobile,
        eventLabel: getRelayEventApprovalLabel(relayEvent),
        whatsappGroupLink,
      })
    : "";
  const chatHref = mobile
    ? toWhatsAppChatHref(mobile, canBuildMessage ? message : undefined)
    : null;

  return {
    itsId,
    name,
    mobile,
    whatsappGroupLink,
    missingLink,
    missingContact,
    canBuildMessage,
    message,
    chatHref,
  };
}
